import { createSlice } from "@reduxjs/toolkit";
import {
  Accessories,
  Bottom,
  Footwear,
  Headwear,
  Jacket,
  Top,
} from "../../assets/images";
import authService from "../../services/auth.service";
import { createApiCase } from "../../helpers/create.api.case";
import { createApiThunk } from "../../helpers/create.api.thunk";
import apiService from "../../services/api.service";
import {
  PrivacyPolicy,
  ReturnPolicy,
  TermsNConditions,
} from "../../assets/pdf";

export const login = createApiThunk("login", authService.login);
export const sendOtp = createApiThunk("sendOtp", authService.sendOtp);
export const getCategoryList = createApiThunk(
  "getCategoryList",
  apiService.getCategoryList
);
export const getCartCount = createApiThunk(
  "getCartCount",
  apiService.getCartCount
);

export const initialData = {
  loginLoading: false,
  sendOtpLoading: false,
  categoryListLoading: false,

  cartCount: 0,
  contactList: [
    // {
    //   tag: "Call",
    //   icon: "fluent:call-28-regular",
    //   label: "+6012-6566969",
    // },
    {
      tag: "Email",
      icon: "hugeicons:at",
      label: "info@dhub.my",
    },
    {
      tag: "Address",
      icon: "carbon:location",
      label: "Bandar Bukit Raja, KL",
    },
  ],
  footerList: {
    description:
      "DC Fashion is a Malaysia-based brand born from car culture, crafting premium apparel and accessories with a focus on quality, fit, and sustainability.",
    opening_hour: [
      {
        label: "Mon-Fri",
        description: "10am-10pm",
      },
      {
        label: "Sat",
        description: "10am-2pm",
      },
    ],
    shortcut: [
      {
        label: "Headwear",
        navigate: "/shop/headwear",
      },
      {
        label: "Top",
        navigate: "/shop/top",
      },
      {
        label: "Jacket",
        navigate: "/shop/jacket",
      },
      {
        label: "Bottom",
        navigate: "/shop/bottom",
      },
      // {
      //   label: "Footwear",
      //   navigate: "/shop/footwear",
      // },
      {
        label: "Accessories",
        navigate: "/shop/accessories",
      },
    ],
    explore: [
      {
        label: "About Us",
        navigate: "/about-us",
      },
      {
        label: "Shop All",
        navigate: "/shop/all",
      },
    ],
    extra: [
      {
        label: "Terms and Conditions",
        href: TermsNConditions,
      },
      {
        label: "Privacy Policy",
        href: PrivacyPolicy,
      },
      {
        label: "Return Policy",
        href: ReturnPolicy,
      },
    ],
  },
  menuList: [
    {
      label: "order",
      icon: "solar:box-outline",
      navigate: "/order",
    },
    {
      label: "cart",
      icon: "lineicons:cart-2",
      navigate: "/cart",
    },
    {
      label: "user",
      icon: "ep:user",
      logout_icon: "si:unlock-line",
      // navigate: "/order",
    },
  ],
  pageList: [
    {
      label: "shop",
      icon: "heroicons:plus-20-solid",
      navigate: "/shop/all",
    },
    {
      label: "about us",
      navigate: "/about-us",
    },
  ],
  categoryList: [
    // {
    //   label: "Headwear",
    //   img: Headwear,
    //   navigate: "/shop/headwear",
    // },
    // {
    //   label: "Top",
    //   img: Top,
    //   navigate: "/shop/top",
    // },
    // {
    //   label: "Jacket",
    //   img: Jacket,
    //   navigate: "/shop/jacket",
    // },
    // {
    //   label: "Bottom",
    //   img: Bottom,
    //   navigate: "/shop/bottom",
    // },
    // {
    //   label: "Footwear",
    //   img: Footwear,
    //   navigate: "/shop/footwear",
    // },
    // {
    //   label: "Accessories",
    //   img: Accessories,
    //   navigate: "/shop/accessories",
    // },
  ],

  isOpenShopDropdown: false,
  isOpenCartDropdown: false,
  isOpenUserDropdown: false,
  isOpenFullLoading: false,
};

const dataSlice = createSlice({
  name: "common",
  initialState: initialData,
  reducers: {
    getRole: (state) => {
      state.role = localStorage.getItem("role");
    },
    getToken: (state) => {
      state.token = localStorage.getItem("token");
    },
    getUserId: (state) => {
      state.userId = localStorage.getItem("user_id");
    },
    getUsername: (state) => {
      state.username = localStorage.getItem("username");
    },

    openShopDropdown: (state) => {
      state.isOpenShopDropdown = true;
    },
    openCartDropdown: (state) => {
      state.isOpenCartDropdown = true;
    },
    openUserDropdown: (state) => {
      state.isOpenUserDropdown = true;
    },
    openFullLoading: (state) => {
      state.isOpenFullLoading = true;
    },
    closeShopDropdown: (state) => {
      state.isOpenShopDropdown = false;
    },
    closeCartDropdown: (state) => {
      state.isOpenCartDropdown = false;
    },
    closeUserDropdown: (state) => {
      state.isOpenUserDropdown = false;
    },
    closeFullLoading: (state) => {
      state.isOpenFullLoading = false;
    },
  },
  extraReducers: (builder) => {
    createApiCase(builder, login, {
      loading: "loginLoading",
    });
    createApiCase(builder, sendOtp, {
      loading: "sendOtpLoading",
    });
    createApiCase(builder, getCategoryList, {
      loading: "categoryListLoading",
      fulfilled: (state, action) => {
        state.categoryList = action.payload.data.aaData;
      },
    });
    createApiCase(builder, getCartCount, {
      fulfilled: (state, action) => {
        state.cartCount = action.payload.data;
      },
    });
  },
});

export const {
  getRole,
  getToken,
  getUserId,
  getUsername,
  openShopDropdown,
  openCartDropdown,
  openUserDropdown,
  openFullLoading,
  closeShopDropdown,
  closeCartDropdown,
  closeUserDropdown,
  closeFullLoading,
} = dataSlice.actions;

export default dataSlice.reducer;
